import { render } from "./SiIntroductionV3.vue?vue&type=template&id=8fd33aba&scoped=true"
import script from "./SiIntroductionV3.vue?vue&type=script&lang=js"
export * from "./SiIntroductionV3.vue?vue&type=script&lang=js"

import "./SiIntroductionV3.vue?vue&type=style&index=0&id=8fd33aba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd33aba"]])

export default __exports__